<template>
    <nav id="nav">
        <router-link to="/" id="logo-url"><img :src="logo" :alt="alt" id="logo"></router-link>
        <router-link to="/">Home</router-link>
        <router-link to="/pedidos">Pedidos</router-link>
    </nav>
</template>

<script lang="js">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Navbar',
    props: {
        logo: "",
        alt:""
    }
})
</script>

<style scoped>
    #nav {
        background-color: #222;
        border-bottom: 4px solid #111;
        padding: 15px 50px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 100%;
    }
    #nav #logo-url{
        margin: auto;
        margin-left: 0;
    }
    #logo{
        width: 40px;
        height: 40px;

    }
    #nav a{
       color: #fcba03;
       text-decoration: none;
       margin: 12px;
       transition: .5;
     
    }
    nav a:hover{
        color: white
    }
</style>

